import * as DOMPurify from "dompurify";

export const sanitizeInput = input => DOMPurify.sanitize(input);
